import React, { Component, PropTypes } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import NavigationBar from '../navigation/NavigationBar';
import config from '../../../config/config';
import { momentSetHKTimezoneWithFormat } from '../../../utils/dateUtils';

const moment = require('moment-timezone');

const appUrlPath = `/${config.appUrlPath}`;

export class SubHeader extends Component {
  constructor() {
    super();
    this.handleLogout = this.handleLogout.bind(this);
    this.close = this.close.bind(this);

    const date = momentSetHKTimezoneWithFormat(moment(), 'DD/MM/YYYY')
    const displayName = localStorage.getItem('displayName');
    const role = localStorage.getItem('role');
    const isPV = localStorage.getItem('isPV');
    const isCV = localStorage.getItem('isCV');
    const isPVCoverNote = localStorage.getItem('isPVCoverNote');
    const isCVCoverNote = localStorage.getItem('isCVCoverNote');
    this.state = {
      date,
      displayName,
      role,
      isPV,
      isCV,
      isPVCoverNote,
      isCVCoverNote,
      showModal: false
    };
  }

  handleLogout() {
    axios.get(`${appUrlPath}/logout`)
    .then(() => {
      window.location = '/en/motorb2b/home';
    })
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    const downloadUserManual = `${appUrlPath}/downloadUserManual`;
    const contactUs = `/en${appUrlPath}/contactus`;
    const LogoImg = `${appUrlPath}/assets/img/axa-header.png`;
    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        <div style={{ display: 'inline-block', width: '100%' }}>
          { this.props.isLogin === 'false' || this.props.isLogin === undefined ?
          <img src={LogoImg} width="113" height="85" alt="axa-header"
            style={{ float: 'left', marginTop: '-20px' }} /> :
          <img src={LogoImg} width="113" height="85" alt="axa-header"
            style={{ marginTop: '-20px' }} />
          }
          { this.props.isLogin === 'false' || this.props.isLogin === undefined ?
          <div className="SubHeader__NavPos" style={{ float: 'left' }}>
            <NavigationBar role={this.state.role} isPV={this.state.isPV} isCV={this.state.isCV}
            isPVCoverNote={this.state.isPVCoverNote} isCVCoverNote={this.state.isCVCoverNote} />
          </div> : null}
          { this.props.isLogin === 'false' || this.props.isLogin === undefined ?
          <ul className="SubHeader__RightSection">
            <li>{this.state.date}</li>
            <li>Logged in as {this.state.displayName}</li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href={downloadUserManual}>User Manual</a>{'  |  '}
              <a target="_blank" rel="noopener noreferrer" href={contactUs}>Contact Us</a>{'  |  '}
              <a href="/en/motorb2b/updatePassword">Update Password</a>{'  |  '}
              <a href="#logout" onClick={this.handleLogout}>Logout</a>
            </li>
          </ul> : null}

        </div>

      </div>
    )
  }
}

SubHeader.propTypes = {
  isLogin: PropTypes.string
};

export default SubHeader;



// WEBPACK FOOTER //
// ./src/app/components/subHeader/SubHeader.js